import React, {ChangeEvent, Component, ComponentState} from "react";
import {ConfirmPopup} from "primereact/confirmpopup";
import ListDraggableItem from "components/custom/ListDraggableItem";
import EmptyComponent from "components/custom/empty-components/EmptyComponent";
import {setSelectedItems} from "redux/actions/ComponentActions";
import {connect, ConnectedProps} from "react-redux";
import RoleHelper from "RoleHelper";
import {Icon} from "@trlogic/ui-pack";
import {query} from "@trlogic/client-js";
import Order = query.Order;
import ComponentName from "../../../constant/ComponentName";
import LanguageUtil from "util/LanguageUtil";
import {CraSegmentType, CraDateSegmentsSchema, CraNumberSegmentsSchema, CraStringSegmentsSchema} from "domain/cra/CraDomains";
import {customConfirm} from "../../../components/custom/CustomPopupConfirm";
import {dispatch, RootState} from "../../../redux/store";
import CustomTable, {CustomColumnProps} from "../../../components/custom/CustomTable";
import CustomInput from "../../../components/custom/CustomInput";

class CraPolicyListViewerComponent extends Component<Props, State> {

  public state: State = new State();

  private editedSegments: Record<string, any> = {};

  public render() {
    const {segments, component: {selectedComponentIds}, onSortChange} = this.props;
    return (segments && segments.length > 0 ?
        <div
          className={"overflow-y-auto h-full min-h-0 scrollable-editor-container flex w-full rounded-lg"}>
          <ConfirmPopup/>
          <CustomTable value={segments}
                       selectionMode="checkbox"
                       selection={selectedComponentIds}
                       onSelectionChange={this.onSelectionChange}
                       componentName={ComponentName.POLICY}
                       openNewTab={true}
                       columns={this.getColumns()}
                       onSortChange={onSortChange}
          />
          <ListDraggableItem itemType={ComponentName.POLICY} currentModal={this.props.currentModal}/>
        </div>
        : <EmptyComponent type={ComponentName.POLICY} createDisabled={true}/>

    );
  }

  public componentDidMount() {
    const {segments} = this.props;
    this.setState({segments, loading: false})
  }

  private updateEditedSegment = (id: string, changes: any) => {
    this.editedSegments[id] = {
      ...(this.editedSegments[id] || {}),
      ...changes
    };
    this.forceUpdate();
  }

  private getSegmentValue = (record: any, field: string) => {
    if (this.editedSegments[record.id] && this.editedSegments[record.id][field] !== undefined) {
      return this.editedSegments[record.id][field];
    }
    return record[field];
  }

  private onInputChange = (record: any, field: string, type: CraSegmentType, e: ChangeEvent<HTMLInputElement>) => {
    const {onChange} = this.props;
    const value = e.target.value;
    this.updateEditedSegment(record.id, {[field]: value});
    if (onChange) {
      onChange({...record, ...this.editedSegments[record.id], [field]: value}, type);
    }
  }

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  }

  private onConfirmDelete = async (record: any, type: CraSegmentType) => {
    const {onDelete} = this.props;
    onDelete && onDelete(record.id);
  }

  private getColumns = (): CustomColumnProps[] => {
    const {type, onChange} = this.props;
    let columns: CustomColumnProps[] = [];

    switch (type as CraSegmentType) {
      case CraSegmentType.STRING:
        columns = [
          {
            field: "value",
            header: LanguageUtil.get({id: "common.label.value", defaultMessage: "Value"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.value,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "value")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "value", type, e);
                }}
              />
            )
          },
          {
            field: "score",
            header: LanguageUtil.get({id: "common.label.score", defaultMessage: "Score"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.score?.toString(),
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "score")}
                inputType="ghost"
                type="number"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "score", type, e);
                }}
              />
            )
          }
        ];
        break;
      case CraSegmentType.NUMBER:
      case CraSegmentType.DATE:
        columns = [
          {
            field: "from",
            header: LanguageUtil.get({id: "common.label.from", defaultMessage: "From"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.from,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "from")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "from", type, e);
                }}
              />
            )
          },
          {
            field: "to",
            header: LanguageUtil.get({id: "common.label.to", defaultMessage: "To"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.to,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "to")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "to", type, e);
                }}
              />
            )
          },
          {
            field: "score",
            header: LanguageUtil.get({id: "common.label.score", defaultMessage: "Score"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.score?.toString(),
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "score")}
                inputType="ghost"
                type="number"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "score", type, e);
                }}
              />
            )
          }
        ];
        break;
      case CraSegmentType.API:
        columns = [
          {
            field: "key",
            header: LanguageUtil.get({id: "key", defaultMessage: "Key"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.key,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "key")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "key", type, e);
                }}
              />
            )
          },
          {
            field: "value",
            header: LanguageUtil.get({id: "value", defaultMessage: "Value"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.value,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "value")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "value", type, e);
                }}
              />
            )
          },
          {
            field: "description",
            header: LanguageUtil.get({id: "description", defaultMessage: "Description"}),
            className: "w-1/6",
            copyable: true,
            onCopy: (e: any) => e.description,
            body: (record: any) => (
              <CustomInput
                value={this.getSegmentValue(record, "description")}
                inputType="ghost"
                type="text"
                disabled={false}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  this.onInputChange(record, "description", type, e);
                }}
              />
            )
          }
        ];
        break;
      default:
        columns = [];
    }

    columns.push({
      field: "action",
      header: LanguageUtil.get({id: "pages.configuration.list.table.action", defaultMessage: "Action"}),
      className: "max-w-[60px] 2xl:max-w-[100px]",
      sortable: false,
      body: (record: any) => (
        <div className={"flex w-full justify-center items-center gap-x-4"}>
          <div onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
            customConfirm({
              target: e.currentTarget,
              accept: () => this.onConfirmDelete(record, type as CraSegmentType),
              message: LanguageUtil.get({id: "messages.confirm.remove1", defaultMessage: "Are you sure you want to remove?"})
            });
          }}>
            <Icon icon={"delete"} size={12} color={"primary"}
                  className={"hover:text-primary text-[#607080] hover:cursor-pointer flex items-center justify-center"}/>
          </div>
        </div>
      )
    });

    return columns.filter(column => {
      if (column.field === "action") {
        return RoleHelper.canEdit("Cra");
      }
      return true;
    });
  }
}

class State {
  segments: CraStringSegmentsSchema[] | CraNumberSegmentsSchema[] | CraDateSegmentsSchema[] = [];
  loading: boolean = true;
}

interface Props extends ReduxProps {
  segments: CraStringSegmentsSchema[] | CraNumberSegmentsSchema[] | CraDateSegmentsSchema[];
  type: CraSegmentType
  views: any
  currentModal: any
  onSortChange: (order: Order[]) => void;
  onDelete?: (id: string) => void;
  onChange?: (segment: CraStringSegmentsSchema | CraNumberSegmentsSchema | CraDateSegmentsSchema, segmentType: CraSegmentType) => void; // eklendi
}

const mapStateToProps = (state: RootState) => ({
  component: state.component as ComponentState
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(CraPolicyListViewerComponent)
